<template>
  <div>
    <apex-chart width="100%" :type="type" :options="chartOptions" :series="series"></apex-chart>
  </div>
</template>

<script>
export default {
  props: {
    appseries: {
      type: Array,
    },
    chartType: {
      type: String,
      required: true
    },
    chartLabels: {
      type: Array,
      default: []
    },
    chartColors: {
      type: Array,
      default: []
    }
  },
  data: function() {
    return {
      chartOptions: {
        labels: this.chartLabels,
        colors: this.chartColors,
      },
      series:this.appseries,
      type: this.chartType,
    }
  }
}
</script>